import React, { useState } from "react";
import AdminLayout from "../layout/AdminLayout";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import SalesChart from "../charts/SalesChart";
import { useLazyGetDashboardSalesQuery } from "../../redux/api/orderApi";
import { useEffect } from "react";
import toast from "react-hot-toast";
import Loader from "../layout/Loader";

const Dashboard = () => {
    const [startDate, setStartDate] = useState(new Date().setDate(1));
    const [endDate, setEndDate] = useState(new Date());

    const [getDashboardSales, { error, isLoading, data }] = useLazyGetDashboardSalesQuery();

    useEffect(() => {
        if (error) {
            toast.error(error?.data?.message);
        }
        if (startDate && endDate && !data) {
            getDashboardSales({
                startDate: new Date(startDate).toISOString(),
                endDate: endDate.toISOString(),
            });
        }
    }, [error, startDate, endDate, data, getDashboardSales]);

    const submitHandler = () => {
        getDashboardSales({
            startDate: new Date(startDate).toISOString(),
            endDate: endDate.toISOString(),
        });
    }

    if (isLoading) return <Loader />

    const gradient = "linear-gradient(135deg, #ffe6ec 0%, #ffbfd2 45%, #e88bab 100%)";
    const purpleText = "#e04f6e";

    return (
        <AdminLayout >
            <div className="dashboard " style={{ fontFamily: "'Quicksand', sans-serif" }}>
                {/* Date Filters */}
                <div className="d-flex flex-wrap justify-content-start align-items-end mb-4 gap-3">
                    <div className="d-flex flex-column">
                        <label className="form-label fw-semibold" style={{ color: "#e04f6e" }}   >
                            Start Date
                        </label>
                        <DatePicker
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                            selectsStart
                            startDate={startDate}
                            endDate={endDate}
                            className="form-control shadow-sm rounded-3"
                        />
                    </div>

                    <div className="d-flex flex-column">
                        <label className="form-label fw-semibold " style={{ color: "#e04f6e" }} >
                            End Date
                        </label>
                        <DatePicker
                            selected={endDate}
                            onChange={(date) => setEndDate(date)}
                            selectsEnd
                            startDate={startDate}
                            endDate={endDate}
                            minDate={startDate}
                            className="form-control shadow-sm rounded-3"
                        />
                    </div>

                    {/* Fetch Button */}
                    <button
                        className="btn px-5 py-2 fw-semibold shadow-sm rounded-3" onClick={submitHandler}
                        style={{
                            background: gradient,
                            border: "none",
                            transition: "all 0.3s ease",
                            color: "#e04f6e",
                        }}
                        onMouseEnter={(e) =>
                        (e.target.style.background =
                            "linear-gradient(135deg, #e57aa0, #ffc1d3)")
                        }
                        onMouseLeave={(e) =>
                            (e.target.style.background = gradient)
                        }
                    >
                        Fetch
                    </button>
                </div>

                {/* Stats Cards */}
                <div className="row g-4 mb-5">
                    {/* Total Sales */}
                    <div className="col-xl-6 col-sm-12">
                        <div
                            className="card border-0 shadow-sm rounded-4 "
                            style={{
                                background: gradient,
                                color: purpleText,
                            }}
                        >
                            <div className="card-body text-center py-4">
                                <h5 className="fw-semibold mb-2 ">Total Sales</h5>
                                <h3 className="fw-bold mb-0">PKR {data?.totalSales?.toFixed(2)}</h3>
                            </div>
                        </div>
                    </div>

                    {/* Total Orders */}
                    <div className="col-xl-6 col-sm-12">
                        <div
                            className="card border-0 shadow-sm rounded-4"
                            style={{
                                background: gradient,
                                color: purpleText,
                            }}
                        >
                            <div className="card-body text-center py-4">
                                <h5 className="fw-semibold mb-2">Total Orders</h5>
                                <h3 className="fw-bold mb-0">{data?.totalNumOrders}</h3>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Chart Section */}
                <div className="card border-0 shadow-sm rounded-4 p-3 bg-white" style={{ border: "1px solid rgba(222, 133, 153, 0.25)" }}>
                    <SalesChart salesData={data?.sales} />
                </div>

                <div className="mb-5"></div>
            </div>
        </AdminLayout>
    );
};

export default Dashboard;
